import { render, staticRenderFns } from "./Nine-2.vue?vue&type=template&id=241fdef2&scoped=true&"
import script from "./Nine-2.vue?vue&type=script&lang=js&"
export * from "./Nine-2.vue?vue&type=script&lang=js&"
import style0 from "./Nine-2.vue?vue&type=style&index=0&id=241fdef2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241fdef2",
  null
  
)

export default component.exports